import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import Menu from "@material-ui/icons/Menu";

// assets
import logoIcon from "assets/img/logo.ico";

// estilos
import styles from "../../customAssets/customAdminNavbarStyle.js";

const useStyles = makeStyles(styles);

export default function AdminNavbar(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { color, brandText, handleDrawerToggle } = props;

  /**
   * Salvaguarda extra:
   * aunque Main.js ya lo condiciona a móvil,
   * este componente no debe mostrarse en desktop.
   */
  if (!isMobile) {
    return null;
  }

  /**
   * Marca fija exacta.
   */
  const headerTitle =
    typeof brandText === "string" && brandText.trim() !== ""
      ? brandText.trim()
      : "ePalSafer";

  const appBarClasses = cx(classes.appBar, {
    [classes[color]]: Boolean(color && classes[color]),
  });

  return (
    <AppBar
      position="sticky"
      color="transparent"
      elevation={0}
      className={appBarClasses}
    >
      <Toolbar className={classes.container}>
        <Box className={classes.leftSlot}>
          <IconButton
            aria-label="open navigation menu"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <Menu className={classes.menuIcon} />
          </IconButton>
        </Box>

        <Box className={classes.centerSlot}>
          <Box className={classes.brandWrap}>
            <Box className={classes.brandLockup}>
              <img
                src={logoIcon}
                alt="ePalSafer"
                className={classes.brandLogo}
              />
              <Typography
                variant="subtitle1"
                title={headerTitle}
                className={classes.brandText}
              >
                {headerTitle}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box className={classes.rightSlot} />
      </Toolbar>
    </AppBar>
  );
}

AdminNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  brandText: PropTypes.string,
  miniActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  sidebarMinimize: PropTypes.func,
  rtlActive: PropTypes.bool,
};